import type { MapGeoJSONFeature } from '@vis.gl/react-maplibre';

import { MapLayer } from '@/types/MapLayer';
import type { ParkingFeature } from '@/types/ParkingFeature';
import type { TrafficReportFeature } from '@/types/TrafficReportFeature';

export class FeatureGuard {
  public static isParkingFeature(feature: MapGeoJSONFeature): feature is ParkingFeature & MapGeoJSONFeature {
    return (MapLayer.PARKING as string) === feature.layer.id || feature.layer.id === 'PARKING_TEST';
  }

  public static isTrafficReportFeature(
    feature: MapGeoJSONFeature,
  ): feature is TrafficReportFeature & MapGeoJSONFeature {
    return (MapLayer.TRAFFIC_REPORT as string) === feature.layer.id || feature.layer.id === 'TRAFFIC_REPORT_TEST';
  }
}
